import { Check, Copy } from 'lucide-react';
import { useEffect, useState } from 'react';

import { Button } from '@/components/ui/button';
import { Tooltip } from '@/components/ui/tooltip';

type CopyButtonProperties = {
  label?: string;
  text: string;
};

export const CopyButton = ({ label = 'Copy', text }: CopyButtonProperties) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) {
      return;
    }
    const timeout = globalThis.setTimeout(() => setCopied(false), 1600);
    return () => globalThis.clearTimeout(timeout);
  }, [copied]);

  return (
    <Tooltip content={copied ? 'Copied' : text}>
      <Button
        onClick={() => {
          void navigator.clipboard.writeText(text);
          setCopied(true);
        }}
        variant="secondary"
      >
        {copied ? <Check aria-hidden="true" className="size-4" /> : <Copy aria-hidden="true" className="size-4" />}
        {copied ? 'Copied' : label}
      </Button>
    </Tooltip>
  );
};
